module.exports = __webpack_public_path__ + "static/media/icon-message.46aa1a9c.svg";